import * as React from "react";

const Arrows: React.FC = () => {
    return <svg width="21px" height="22px" viewBox="0 0 21 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-804.000000, -234.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(724.000000, 4.000000)">
                    <g transform="translate(1.000000, 0.000000)">
                        <path d="M5.81056433,19.3175223 L5.81056433,0 L4.23913575,0 L4.23913575,19.3175223 L1.13560268,16.2139892 L0.0245535714,17.3250384 L4.46932549,21.7698103 C4.77624513,22.0765381 5.27345495,22.0765381 5.58037459,21.7698103 L10.0251465,17.3250384 L8.9140974,16.2139892 L5.81056433,19.3175223 Z"></path>
                        <path d="M21.0251465,4.67496165 L16.5803746,0.230189732 C16.273455,-0.0765380982 15.7762451,-0.0765380982 15.4693255,0.230189732 L11.0245536,4.67496165 L12.1356027,5.78601075 L15.2391358,2.68247768 L15.2391358,22 L16.8105643,22 L16.8105643,2.68247768 L19.9140974,5.78601075 L21.0251465,4.67496165 Z"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Arrows);
